module.exports = __webpack_public_path__ + "img/cart-masterclass-paid@2x.61827f0a.png";